import { useEffect, useRef } from 'react';

/**
 * Invokes a callback function at a specified interval.
 *
 * @param {Function} callback - The function to be called on each interval.
 * @param {number|null} delay - The time, in milliseconds, between each execution of the callback. If null, the interval is cleared.
 */
export const useInterval = (callback, delay) => {
  const savedCallback = useRef(() => {});

  useEffect(() => {
    savedCallback.current = callback;
  });

  useEffect(() => {
    // Don't schedule if no delay is specified.
    // Note: 0 is a valid value for delay.
    if (delay === null) {
      return;
    }

    const id = setInterval(() => {
      savedCallback.current();
    }, delay);

    return () => {
      clearInterval(id);
    };
  }, [delay]);
};
